import React, { useReducer, useEffect, useMemo } from 'react';
import { Box, Tooltip, TextField, IconButton } from '@mui/material';
import DefaultModal from '../../Utils/DefaultModal';
import { lockedReducer } from '../../Utils/reducers';
import Table, { TableHook } from '../../Table';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import EditRename from './editRename';
import { api } from '../../../services/api';
import ConfirmationDialog from '../../Utils/ConfirmationDialog';
import { deleteRow } from '../../Distribuicao/functionsCore';

import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

const getcolumnsRenameTable = (state, setState) => {
    const columns = []
    columns.push({ field: 'nome_empresa', headerName: 'Empresa', width: 250 })
    columns.push({ field: 'rename', headerName: 'Rename', flex: 1 })
    columns.push({
        field: 'acoes',
        headerName: 'Ações',
        width: 150,
        renderCell: (props) => {
            return (
                <Box>
                    <Tooltip title='Editar tabela'><IconButton onClick={() => { setState({ editRow: props.row }) }}><EditIcon /></IconButton></Tooltip>
                    <Tooltip title='Deleta tabela'><IconButton onClick={() => { setState({ deleteRow: props.row }) }}><DeleteIcon /></IconButton></Tooltip>
                </Box>
            )
        }
    })

    return columns
}

const getEmpresaRename = async (setLoader, setState) => {
    setLoader(true)
    const res = await api.get(`/consulta_rename/`)
    if (res.status === 200) {
        setState({ rows: res.data })
    }
    setLoader(false)
}

const deleteEmpresaRename = async (setLoader, setState, getEmpresaRename, id) => {
    setLoader(true)
    const res = await api.delete(`/consulta_rename/${id}`)
    if (res.status === 200) {
        getEmpresaRename(setLoader, setState)
        setState({ deleteRow: null })
    }
    setLoader(false)
}

const RenameModal = ({ data, handleClose, setLoader }) => {

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        rows2: [],
        editRow: null,
        deleteRow: null
    })

    const [tableRenameEmpresa] = TableHook()

    useEffect(() => {
        getEmpresaRename(setLoader, setState)
    }, [])

    return (
        <>
            {
                state.editRow &&
                <EditRename
                    data={state.editRow}
                    handleClose={() => setState({ editRow: null })}
                    reloadData={getEmpresaRename}
                    setLoader={setLoader}
                    setConsultas={setState}
                />
            }

            {
                state.deleteRow &&
                <ConfirmationDialog
                    content={`Deseja excluir a renomeação de coluna da empresa ${state.deleteRow.rename} ?`}
                    handleClose={() => setState({ deleteRow: null })}
                    onConfirm={() => deleteEmpresaRename(setLoader, setState, getEmpresaRename, state.deleteRow.id)}
                />

            }


            <DefaultModal
                dialogProps={{
                    sx: {
                        '& .MuiPaper-root': {
                            maxWidth: 'unset',
                            maxHeight: 'unset',
                            width: '50%',
                            height: '90%',
                            margin: '0px',

                            '@media (min-width: 1600px)': {
                                width: '80%', // Largura para telas maiores
                                height: '80%', // Altura para telas maiores
                            },
                        }
                    }
                }}
                handleClose={handleClose}
                open={true}
                title={`Renomear empresa`}
                content={
                    <Box>
                        <Stack sx={{ width: '100%', marginBottom: '1rem', gap: '1rem' }} spacing={2}>
                            <Alert sx={{ width: '100%!important' }} severity="info">Colunas com o mesmo nome terão seus valores somados.</Alert>
                            <Alert sx={{ width: '100%!important' }} severity="info">Colunas que contém "BKS" na renomeação será considerado como dispbks na distribuição</Alert>
                        </Stack>

                        <Box className='item-content-modal noborder' sx={{ height: '30rem', minHeight: '1rem' }}>
                            <Table
                                key='rename-table'
                                paginationMode='client'
                                className='contabil-grid'
                                rows={state.rows}
                                columns={useMemo(() => getcolumnsRenameTable(state, setState))}
                                rowHeight={30}
                                toolbar
                                slots={{
                                    addComponent: () => setState({ editRow: {} }),
                                    columnComponent: true
                                }}
                                innerRef={tableRenameEmpresa}
                            />
                        </Box>
                    </Box>
                }
            />

        </>
    )
}

export default RenameModal;